export default __webpack_public_path__ + "static/media/marketing.2af0e00f.png";